export function getView(automation) {
  return (
    automation.appointment_status.includes('SCHEDULED') &&
    automation.automation_type === 'automatic'
  )
}
